/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthAdminRouteRouteImport } from './routes/_auth/_admin/route'
import { Route as AuthWithdrawalsIndexRouteImport } from './routes/_auth/withdrawals/index'
import { Route as AuthProfileIndexRouteImport } from './routes/_auth/profile/index'
import { Route as AuthDepositsIndexRouteImport } from './routes/_auth/deposits/index'
import { Route as AuthWithdrawalsIdRouteImport } from './routes/_auth/withdrawals/$id'
import { Route as AuthDepositsAddressRouteImport } from './routes/_auth/deposits/$address'
import { Route as AuthAdminAdminIndexRouteImport } from './routes/_auth/_admin/admin/index'
import { Route as AuthAdminAdminWebhookDeliveriesIndexRouteImport } from './routes/_auth/_admin/admin/webhook-deliveries/index'
import { Route as AuthAdminAdminWalletsIndexRouteImport } from './routes/_auth/_admin/admin/wallets/index'
import { Route as AuthAdminAdminUsersIndexRouteImport } from './routes/_auth/_admin/admin/users/index'
import { Route as AuthAdminAdminTransactionsIndexRouteImport } from './routes/_auth/_admin/admin/transactions/index'
import { Route as AuthAdminAdminStatisticsIndexRouteImport } from './routes/_auth/_admin/admin/statistics/index'
import { Route as AuthAdminAdminSettingsIndexRouteImport } from './routes/_auth/_admin/admin/settings/index'
import { Route as AuthAdminAdminHealthIndexRouteImport } from './routes/_auth/_admin/admin/health/index'
import { Route as AuthAdminAdminFinancialIndexRouteImport } from './routes/_auth/_admin/admin/financial/index'
import { Route as AuthAdminAdminBalanceLogsIndexRouteImport } from './routes/_auth/_admin/admin/balance-logs/index'
import { Route as AuthAdminAdminActivityLogsIndexRouteImport } from './routes/_auth/_admin/admin/activity-logs/index'
import { Route as AuthAdminAdminWalletsPoolRouteImport } from './routes/_auth/_admin/admin/wallets/pool'
import { Route as AuthAdminAdminWalletsHotWalletRouteImport } from './routes/_auth/_admin/admin/wallets/hot-wallet'
import { Route as AuthAdminAdminWalletsDeletedRouteImport } from './routes/_auth/_admin/admin/wallets/deleted'
import { Route as AuthAdminAdminUsersIdRouteImport } from './routes/_auth/_admin/admin/users/$id'
import { Route as AuthAdminAdminTransactionsIdRouteImport } from './routes/_auth/_admin/admin/transactions/$id'
import { Route as AuthAdminAdminWalletsClientStaticIndexRouteImport } from './routes/_auth/_admin/admin/wallets/client-static/index'
import { Route as AuthAdminAdminWalletsClientStaticIdRouteImport } from './routes/_auth/_admin/admin/wallets/client-static/$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAdminRouteRoute = AuthAdminRouteRouteImport.update({
  id: '/_admin',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthWithdrawalsIndexRoute = AuthWithdrawalsIndexRouteImport.update({
  id: '/withdrawals/',
  path: '/withdrawals/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthProfileIndexRoute = AuthProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthDepositsIndexRoute = AuthDepositsIndexRouteImport.update({
  id: '/deposits/',
  path: '/deposits/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthWithdrawalsIdRoute = AuthWithdrawalsIdRouteImport.update({
  id: '/withdrawals/$id',
  path: '/withdrawals/$id',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthDepositsAddressRoute = AuthDepositsAddressRouteImport.update({
  id: '/deposits/$address',
  path: '/deposits/$address',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthAdminAdminIndexRoute = AuthAdminAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminAdminWebhookDeliveriesIndexRoute =
  AuthAdminAdminWebhookDeliveriesIndexRouteImport.update({
    id: '/admin/webhook-deliveries/',
    path: '/admin/webhook-deliveries/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any)
const AuthAdminAdminWalletsIndexRoute =
  AuthAdminAdminWalletsIndexRouteImport.update({
    id: '/admin/wallets/',
    path: '/admin/wallets/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any)
const AuthAdminAdminUsersIndexRoute =
  AuthAdminAdminUsersIndexRouteImport.update({
    id: '/admin/users/',
    path: '/admin/users/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any)
const AuthAdminAdminTransactionsIndexRoute =
  AuthAdminAdminTransactionsIndexRouteImport.update({
    id: '/admin/transactions/',
    path: '/admin/transactions/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any)
const AuthAdminAdminStatisticsIndexRoute =
  AuthAdminAdminStatisticsIndexRouteImport.update({
    id: '/admin/statistics/',
    path: '/admin/statistics/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any)
const AuthAdminAdminSettingsIndexRoute =
  AuthAdminAdminSettingsIndexRouteImport.update({
    id: '/admin/settings/',
    path: '/admin/settings/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any)
const AuthAdminAdminHealthIndexRoute =
  AuthAdminAdminHealthIndexRouteImport.update({
    id: '/admin/health/',
    path: '/admin/health/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any)
const AuthAdminAdminFinancialIndexRoute =
  AuthAdminAdminFinancialIndexRouteImport.update({
    id: '/admin/financial/',
    path: '/admin/financial/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any)
const AuthAdminAdminBalanceLogsIndexRoute =
  AuthAdminAdminBalanceLogsIndexRouteImport.update({
    id: '/admin/balance-logs/',
    path: '/admin/balance-logs/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any)
const AuthAdminAdminActivityLogsIndexRoute =
  AuthAdminAdminActivityLogsIndexRouteImport.update({
    id: '/admin/activity-logs/',
    path: '/admin/activity-logs/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any)
const AuthAdminAdminWalletsPoolRoute =
  AuthAdminAdminWalletsPoolRouteImport.update({
    id: '/admin/wallets/pool',
    path: '/admin/wallets/pool',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any)
const AuthAdminAdminWalletsHotWalletRoute =
  AuthAdminAdminWalletsHotWalletRouteImport.update({
    id: '/admin/wallets/hot-wallet',
    path: '/admin/wallets/hot-wallet',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any)
const AuthAdminAdminWalletsDeletedRoute =
  AuthAdminAdminWalletsDeletedRouteImport.update({
    id: '/admin/wallets/deleted',
    path: '/admin/wallets/deleted',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any)
const AuthAdminAdminUsersIdRoute = AuthAdminAdminUsersIdRouteImport.update({
  id: '/admin/users/$id',
  path: '/admin/users/$id',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminAdminTransactionsIdRoute =
  AuthAdminAdminTransactionsIdRouteImport.update({
    id: '/admin/transactions/$id',
    path: '/admin/transactions/$id',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any)
const AuthAdminAdminWalletsClientStaticIndexRoute =
  AuthAdminAdminWalletsClientStaticIndexRouteImport.update({
    id: '/admin/wallets/client-static/',
    path: '/admin/wallets/client-static/',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any)
const AuthAdminAdminWalletsClientStaticIdRoute =
  AuthAdminAdminWalletsClientStaticIdRouteImport.update({
    id: '/admin/wallets/client-static/$id',
    path: '/admin/wallets/client-static/$id',
    getParentRoute: () => AuthAdminRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/deposits/$address': typeof AuthDepositsAddressRoute
  '/withdrawals/$id': typeof AuthWithdrawalsIdRoute
  '/deposits': typeof AuthDepositsIndexRoute
  '/profile': typeof AuthProfileIndexRoute
  '/withdrawals': typeof AuthWithdrawalsIndexRoute
  '/admin': typeof AuthAdminAdminIndexRoute
  '/admin/transactions/$id': typeof AuthAdminAdminTransactionsIdRoute
  '/admin/users/$id': typeof AuthAdminAdminUsersIdRoute
  '/admin/wallets/deleted': typeof AuthAdminAdminWalletsDeletedRoute
  '/admin/wallets/hot-wallet': typeof AuthAdminAdminWalletsHotWalletRoute
  '/admin/wallets/pool': typeof AuthAdminAdminWalletsPoolRoute
  '/admin/activity-logs': typeof AuthAdminAdminActivityLogsIndexRoute
  '/admin/balance-logs': typeof AuthAdminAdminBalanceLogsIndexRoute
  '/admin/financial': typeof AuthAdminAdminFinancialIndexRoute
  '/admin/health': typeof AuthAdminAdminHealthIndexRoute
  '/admin/settings': typeof AuthAdminAdminSettingsIndexRoute
  '/admin/statistics': typeof AuthAdminAdminStatisticsIndexRoute
  '/admin/transactions': typeof AuthAdminAdminTransactionsIndexRoute
  '/admin/users': typeof AuthAdminAdminUsersIndexRoute
  '/admin/wallets': typeof AuthAdminAdminWalletsIndexRoute
  '/admin/webhook-deliveries': typeof AuthAdminAdminWebhookDeliveriesIndexRoute
  '/admin/wallets/client-static/$id': typeof AuthAdminAdminWalletsClientStaticIdRoute
  '/admin/wallets/client-static': typeof AuthAdminAdminWalletsClientStaticIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/deposits/$address': typeof AuthDepositsAddressRoute
  '/withdrawals/$id': typeof AuthWithdrawalsIdRoute
  '/deposits': typeof AuthDepositsIndexRoute
  '/profile': typeof AuthProfileIndexRoute
  '/withdrawals': typeof AuthWithdrawalsIndexRoute
  '/admin': typeof AuthAdminAdminIndexRoute
  '/admin/transactions/$id': typeof AuthAdminAdminTransactionsIdRoute
  '/admin/users/$id': typeof AuthAdminAdminUsersIdRoute
  '/admin/wallets/deleted': typeof AuthAdminAdminWalletsDeletedRoute
  '/admin/wallets/hot-wallet': typeof AuthAdminAdminWalletsHotWalletRoute
  '/admin/wallets/pool': typeof AuthAdminAdminWalletsPoolRoute
  '/admin/activity-logs': typeof AuthAdminAdminActivityLogsIndexRoute
  '/admin/balance-logs': typeof AuthAdminAdminBalanceLogsIndexRoute
  '/admin/financial': typeof AuthAdminAdminFinancialIndexRoute
  '/admin/health': typeof AuthAdminAdminHealthIndexRoute
  '/admin/settings': typeof AuthAdminAdminSettingsIndexRoute
  '/admin/statistics': typeof AuthAdminAdminStatisticsIndexRoute
  '/admin/transactions': typeof AuthAdminAdminTransactionsIndexRoute
  '/admin/users': typeof AuthAdminAdminUsersIndexRoute
  '/admin/wallets': typeof AuthAdminAdminWalletsIndexRoute
  '/admin/webhook-deliveries': typeof AuthAdminAdminWebhookDeliveriesIndexRoute
  '/admin/wallets/client-static/$id': typeof AuthAdminAdminWalletsClientStaticIdRoute
  '/admin/wallets/client-static': typeof AuthAdminAdminWalletsClientStaticIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/_admin': typeof AuthAdminRouteRouteWithChildren
  '/_auth/deposits/$address': typeof AuthDepositsAddressRoute
  '/_auth/withdrawals/$id': typeof AuthWithdrawalsIdRoute
  '/_auth/deposits/': typeof AuthDepositsIndexRoute
  '/_auth/profile/': typeof AuthProfileIndexRoute
  '/_auth/withdrawals/': typeof AuthWithdrawalsIndexRoute
  '/_auth/_admin/admin/': typeof AuthAdminAdminIndexRoute
  '/_auth/_admin/admin/transactions/$id': typeof AuthAdminAdminTransactionsIdRoute
  '/_auth/_admin/admin/users/$id': typeof AuthAdminAdminUsersIdRoute
  '/_auth/_admin/admin/wallets/deleted': typeof AuthAdminAdminWalletsDeletedRoute
  '/_auth/_admin/admin/wallets/hot-wallet': typeof AuthAdminAdminWalletsHotWalletRoute
  '/_auth/_admin/admin/wallets/pool': typeof AuthAdminAdminWalletsPoolRoute
  '/_auth/_admin/admin/activity-logs/': typeof AuthAdminAdminActivityLogsIndexRoute
  '/_auth/_admin/admin/balance-logs/': typeof AuthAdminAdminBalanceLogsIndexRoute
  '/_auth/_admin/admin/financial/': typeof AuthAdminAdminFinancialIndexRoute
  '/_auth/_admin/admin/health/': typeof AuthAdminAdminHealthIndexRoute
  '/_auth/_admin/admin/settings/': typeof AuthAdminAdminSettingsIndexRoute
  '/_auth/_admin/admin/statistics/': typeof AuthAdminAdminStatisticsIndexRoute
  '/_auth/_admin/admin/transactions/': typeof AuthAdminAdminTransactionsIndexRoute
  '/_auth/_admin/admin/users/': typeof AuthAdminAdminUsersIndexRoute
  '/_auth/_admin/admin/wallets/': typeof AuthAdminAdminWalletsIndexRoute
  '/_auth/_admin/admin/webhook-deliveries/': typeof AuthAdminAdminWebhookDeliveriesIndexRoute
  '/_auth/_admin/admin/wallets/client-static/$id': typeof AuthAdminAdminWalletsClientStaticIdRoute
  '/_auth/_admin/admin/wallets/client-static/': typeof AuthAdminAdminWalletsClientStaticIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/deposits/$address'
    | '/withdrawals/$id'
    | '/deposits'
    | '/profile'
    | '/withdrawals'
    | '/admin'
    | '/admin/transactions/$id'
    | '/admin/users/$id'
    | '/admin/wallets/deleted'
    | '/admin/wallets/hot-wallet'
    | '/admin/wallets/pool'
    | '/admin/activity-logs'
    | '/admin/balance-logs'
    | '/admin/financial'
    | '/admin/health'
    | '/admin/settings'
    | '/admin/statistics'
    | '/admin/transactions'
    | '/admin/users'
    | '/admin/wallets'
    | '/admin/webhook-deliveries'
    | '/admin/wallets/client-static/$id'
    | '/admin/wallets/client-static'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/deposits/$address'
    | '/withdrawals/$id'
    | '/deposits'
    | '/profile'
    | '/withdrawals'
    | '/admin'
    | '/admin/transactions/$id'
    | '/admin/users/$id'
    | '/admin/wallets/deleted'
    | '/admin/wallets/hot-wallet'
    | '/admin/wallets/pool'
    | '/admin/activity-logs'
    | '/admin/balance-logs'
    | '/admin/financial'
    | '/admin/health'
    | '/admin/settings'
    | '/admin/statistics'
    | '/admin/transactions'
    | '/admin/users'
    | '/admin/wallets'
    | '/admin/webhook-deliveries'
    | '/admin/wallets/client-static/$id'
    | '/admin/wallets/client-static'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/_admin'
    | '/_auth/deposits/$address'
    | '/_auth/withdrawals/$id'
    | '/_auth/deposits/'
    | '/_auth/profile/'
    | '/_auth/withdrawals/'
    | '/_auth/_admin/admin/'
    | '/_auth/_admin/admin/transactions/$id'
    | '/_auth/_admin/admin/users/$id'
    | '/_auth/_admin/admin/wallets/deleted'
    | '/_auth/_admin/admin/wallets/hot-wallet'
    | '/_auth/_admin/admin/wallets/pool'
    | '/_auth/_admin/admin/activity-logs/'
    | '/_auth/_admin/admin/balance-logs/'
    | '/_auth/_admin/admin/financial/'
    | '/_auth/_admin/admin/health/'
    | '/_auth/_admin/admin/settings/'
    | '/_auth/_admin/admin/statistics/'
    | '/_auth/_admin/admin/transactions/'
    | '/_auth/_admin/admin/users/'
    | '/_auth/_admin/admin/wallets/'
    | '/_auth/_admin/admin/webhook-deliveries/'
    | '/_auth/_admin/admin/wallets/client-static/$id'
    | '/_auth/_admin/admin/wallets/client-static/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_admin': {
      id: '/_auth/_admin'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthAdminRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/withdrawals/': {
      id: '/_auth/withdrawals/'
      path: '/withdrawals'
      fullPath: '/withdrawals'
      preLoaderRoute: typeof AuthWithdrawalsIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/profile/': {
      id: '/_auth/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthProfileIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/deposits/': {
      id: '/_auth/deposits/'
      path: '/deposits'
      fullPath: '/deposits'
      preLoaderRoute: typeof AuthDepositsIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/withdrawals/$id': {
      id: '/_auth/withdrawals/$id'
      path: '/withdrawals/$id'
      fullPath: '/withdrawals/$id'
      preLoaderRoute: typeof AuthWithdrawalsIdRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/deposits/$address': {
      id: '/_auth/deposits/$address'
      path: '/deposits/$address'
      fullPath: '/deposits/$address'
      preLoaderRoute: typeof AuthDepositsAddressRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/_admin/admin/': {
      id: '/_auth/_admin/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminAdminIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/webhook-deliveries/': {
      id: '/_auth/_admin/admin/webhook-deliveries/'
      path: '/admin/webhook-deliveries'
      fullPath: '/admin/webhook-deliveries'
      preLoaderRoute: typeof AuthAdminAdminWebhookDeliveriesIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/wallets/': {
      id: '/_auth/_admin/admin/wallets/'
      path: '/admin/wallets'
      fullPath: '/admin/wallets'
      preLoaderRoute: typeof AuthAdminAdminWalletsIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/users/': {
      id: '/_auth/_admin/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthAdminAdminUsersIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/transactions/': {
      id: '/_auth/_admin/admin/transactions/'
      path: '/admin/transactions'
      fullPath: '/admin/transactions'
      preLoaderRoute: typeof AuthAdminAdminTransactionsIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/statistics/': {
      id: '/_auth/_admin/admin/statistics/'
      path: '/admin/statistics'
      fullPath: '/admin/statistics'
      preLoaderRoute: typeof AuthAdminAdminStatisticsIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/settings/': {
      id: '/_auth/_admin/admin/settings/'
      path: '/admin/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AuthAdminAdminSettingsIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/health/': {
      id: '/_auth/_admin/admin/health/'
      path: '/admin/health'
      fullPath: '/admin/health'
      preLoaderRoute: typeof AuthAdminAdminHealthIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/financial/': {
      id: '/_auth/_admin/admin/financial/'
      path: '/admin/financial'
      fullPath: '/admin/financial'
      preLoaderRoute: typeof AuthAdminAdminFinancialIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/balance-logs/': {
      id: '/_auth/_admin/admin/balance-logs/'
      path: '/admin/balance-logs'
      fullPath: '/admin/balance-logs'
      preLoaderRoute: typeof AuthAdminAdminBalanceLogsIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/activity-logs/': {
      id: '/_auth/_admin/admin/activity-logs/'
      path: '/admin/activity-logs'
      fullPath: '/admin/activity-logs'
      preLoaderRoute: typeof AuthAdminAdminActivityLogsIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/wallets/pool': {
      id: '/_auth/_admin/admin/wallets/pool'
      path: '/admin/wallets/pool'
      fullPath: '/admin/wallets/pool'
      preLoaderRoute: typeof AuthAdminAdminWalletsPoolRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/wallets/hot-wallet': {
      id: '/_auth/_admin/admin/wallets/hot-wallet'
      path: '/admin/wallets/hot-wallet'
      fullPath: '/admin/wallets/hot-wallet'
      preLoaderRoute: typeof AuthAdminAdminWalletsHotWalletRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/wallets/deleted': {
      id: '/_auth/_admin/admin/wallets/deleted'
      path: '/admin/wallets/deleted'
      fullPath: '/admin/wallets/deleted'
      preLoaderRoute: typeof AuthAdminAdminWalletsDeletedRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/users/$id': {
      id: '/_auth/_admin/admin/users/$id'
      path: '/admin/users/$id'
      fullPath: '/admin/users/$id'
      preLoaderRoute: typeof AuthAdminAdminUsersIdRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/transactions/$id': {
      id: '/_auth/_admin/admin/transactions/$id'
      path: '/admin/transactions/$id'
      fullPath: '/admin/transactions/$id'
      preLoaderRoute: typeof AuthAdminAdminTransactionsIdRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/wallets/client-static/': {
      id: '/_auth/_admin/admin/wallets/client-static/'
      path: '/admin/wallets/client-static'
      fullPath: '/admin/wallets/client-static'
      preLoaderRoute: typeof AuthAdminAdminWalletsClientStaticIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/admin/wallets/client-static/$id': {
      id: '/_auth/_admin/admin/wallets/client-static/$id'
      path: '/admin/wallets/client-static/$id'
      fullPath: '/admin/wallets/client-static/$id'
      preLoaderRoute: typeof AuthAdminAdminWalletsClientStaticIdRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
  }
}

interface AuthAdminRouteRouteChildren {
  AuthAdminAdminIndexRoute: typeof AuthAdminAdminIndexRoute
  AuthAdminAdminTransactionsIdRoute: typeof AuthAdminAdminTransactionsIdRoute
  AuthAdminAdminUsersIdRoute: typeof AuthAdminAdminUsersIdRoute
  AuthAdminAdminWalletsDeletedRoute: typeof AuthAdminAdminWalletsDeletedRoute
  AuthAdminAdminWalletsHotWalletRoute: typeof AuthAdminAdminWalletsHotWalletRoute
  AuthAdminAdminWalletsPoolRoute: typeof AuthAdminAdminWalletsPoolRoute
  AuthAdminAdminActivityLogsIndexRoute: typeof AuthAdminAdminActivityLogsIndexRoute
  AuthAdminAdminBalanceLogsIndexRoute: typeof AuthAdminAdminBalanceLogsIndexRoute
  AuthAdminAdminFinancialIndexRoute: typeof AuthAdminAdminFinancialIndexRoute
  AuthAdminAdminHealthIndexRoute: typeof AuthAdminAdminHealthIndexRoute
  AuthAdminAdminSettingsIndexRoute: typeof AuthAdminAdminSettingsIndexRoute
  AuthAdminAdminStatisticsIndexRoute: typeof AuthAdminAdminStatisticsIndexRoute
  AuthAdminAdminTransactionsIndexRoute: typeof AuthAdminAdminTransactionsIndexRoute
  AuthAdminAdminUsersIndexRoute: typeof AuthAdminAdminUsersIndexRoute
  AuthAdminAdminWalletsIndexRoute: typeof AuthAdminAdminWalletsIndexRoute
  AuthAdminAdminWebhookDeliveriesIndexRoute: typeof AuthAdminAdminWebhookDeliveriesIndexRoute
  AuthAdminAdminWalletsClientStaticIdRoute: typeof AuthAdminAdminWalletsClientStaticIdRoute
  AuthAdminAdminWalletsClientStaticIndexRoute: typeof AuthAdminAdminWalletsClientStaticIndexRoute
}

const AuthAdminRouteRouteChildren: AuthAdminRouteRouteChildren = {
  AuthAdminAdminIndexRoute: AuthAdminAdminIndexRoute,
  AuthAdminAdminTransactionsIdRoute: AuthAdminAdminTransactionsIdRoute,
  AuthAdminAdminUsersIdRoute: AuthAdminAdminUsersIdRoute,
  AuthAdminAdminWalletsDeletedRoute: AuthAdminAdminWalletsDeletedRoute,
  AuthAdminAdminWalletsHotWalletRoute: AuthAdminAdminWalletsHotWalletRoute,
  AuthAdminAdminWalletsPoolRoute: AuthAdminAdminWalletsPoolRoute,
  AuthAdminAdminActivityLogsIndexRoute: AuthAdminAdminActivityLogsIndexRoute,
  AuthAdminAdminBalanceLogsIndexRoute: AuthAdminAdminBalanceLogsIndexRoute,
  AuthAdminAdminFinancialIndexRoute: AuthAdminAdminFinancialIndexRoute,
  AuthAdminAdminHealthIndexRoute: AuthAdminAdminHealthIndexRoute,
  AuthAdminAdminSettingsIndexRoute: AuthAdminAdminSettingsIndexRoute,
  AuthAdminAdminStatisticsIndexRoute: AuthAdminAdminStatisticsIndexRoute,
  AuthAdminAdminTransactionsIndexRoute: AuthAdminAdminTransactionsIndexRoute,
  AuthAdminAdminUsersIndexRoute: AuthAdminAdminUsersIndexRoute,
  AuthAdminAdminWalletsIndexRoute: AuthAdminAdminWalletsIndexRoute,
  AuthAdminAdminWebhookDeliveriesIndexRoute:
    AuthAdminAdminWebhookDeliveriesIndexRoute,
  AuthAdminAdminWalletsClientStaticIdRoute:
    AuthAdminAdminWalletsClientStaticIdRoute,
  AuthAdminAdminWalletsClientStaticIndexRoute:
    AuthAdminAdminWalletsClientStaticIndexRoute,
}

const AuthAdminRouteRouteWithChildren = AuthAdminRouteRoute._addFileChildren(
  AuthAdminRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthAdminRouteRoute: typeof AuthAdminRouteRouteWithChildren
  AuthDepositsAddressRoute: typeof AuthDepositsAddressRoute
  AuthWithdrawalsIdRoute: typeof AuthWithdrawalsIdRoute
  AuthDepositsIndexRoute: typeof AuthDepositsIndexRoute
  AuthProfileIndexRoute: typeof AuthProfileIndexRoute
  AuthWithdrawalsIndexRoute: typeof AuthWithdrawalsIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthAdminRouteRoute: AuthAdminRouteRouteWithChildren,
  AuthDepositsAddressRoute: AuthDepositsAddressRoute,
  AuthWithdrawalsIdRoute: AuthWithdrawalsIdRoute,
  AuthDepositsIndexRoute: AuthDepositsIndexRoute,
  AuthProfileIndexRoute: AuthProfileIndexRoute,
  AuthWithdrawalsIndexRoute: AuthWithdrawalsIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
